import React, { useEffect } from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ContainerResponsive from "../../common/components/ContainerResponsive";
import ProfileHeader from "../components/ProfileHeader";

export default function Profile() {
  const location = useLocation();
  const navigate = useNavigate();
  const tab = location.pathname.split("/").pop();
  const tabs = { Skills: "Massimali", Workouts: "Allenamenti" };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (tab == "Profile") {
      navigate(location.pathname + "/Skills");
    }
  }, [location.pathname]);

  return (
    <div>
      <ProfileHeader tabs={tabs} />
      <ContainerResponsive>
        <Outlet />
      </ContainerResponsive>
    </div>
  );
}
